import { gql } from "@apollo/client";

export const CREATE_LIVE = gql`
  mutation CreateLive($data: LiveInput!) {
    createLive(data: $data) {
        id
    }
}
`;

export const CREATE_LIVE_WITH_LIVE_STOCK_AND_UPDATE_STOCK = gql`
  mutation CreateLiveWithLiveStockAndUpdateStock($data: LiveWithStockInput) {
    createLiveWithLiveStockAndUpdateStock(data: $data) {
      id
    }
}`;

export const UPDATE_LIVE = gql`
  mutation UpdateLive($data: LiveInput!,$where: LiveWhereInputOne!) {
    updateLive(where: $where, data:$data) {
        id
    }
}
`;

export const DELETE_LIVE = gql`
  mutation DeleteLive($where: LiveWhereInputOne!) {
    deleteLive(where: $where) {
        id
    }
}
`;
export const SELECT_STOCK_TO_LIVE = gql`
  mutation SelectStockToLive($id: ID!) {
  selectStockToLive(id: $id) {
    id
  }
}
`;